module.exports = __webpack_public_path__ + "static/media/icon-teams-roles-pagination-right.ac663e4e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/assets/icon-teams-roles-pagination-right.svg
// module id = 688
// module chunks = 0